/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_NB_NO: Record<string, string> = {
    ariaAnnounceChart: 'diagram, ${seriesCount}[number] serier',
    ariaAnnounceFlowProportionLink: 'lenke ${index} av ${count}, fra ${from} til ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'node ${index} av ${count}, ${description}',
    ariaAnnounceGaugeChart: 'målerdiagram, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarkidiagram, ${caption}',
    ariaAnnounceHierarchyDatum: 'nivå ${level}[number], ${count}[number] barn, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Trykk på mellomromstasten eller Enter for å bytte synlighet',
    ariaLabelAddHorizontalLine: 'Legg til horisontal linje',
    ariaLabelAnnotationOptionsToolbar: 'Merknadsalternativer',
    ariaLabelAnnotationSettingsDialog: 'Kommentarinnstillinger',
    ariaLabelColorPicker: 'Fargevelger',
    ariaLabelFinancialCharts: 'Finansielle diagrammer',
    ariaLabelLegend: 'Forklaring',
    ariaLabelLegendItem: '${label}, Legendepost ${index}[number] av ${count}[number]',
    ariaLabelLegendItemUnknown: 'Ukjent legendeelement',
    ariaLabelLegendPageNext: 'Neste legende side',
    ariaLabelLegendPagePrevious: 'Forrige legende-side',
    ariaLabelLegendPagination: 'Paginering av legenden',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maksimum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Område',
    ariaLabelRangesToolbar: 'Områder',
    ariaLabelSettingsTabBar: 'Innstillinger',
    ariaLabelZoomToolbar: 'Zoom',
    ariaValuePanRange: '${min}[percent0to2dp] til ${max}[percent0to2dp]',
    contextMenuDownload: 'Last ned',
    contextMenuPanToCursor: 'Panorer til dette punktet',
    contextMenuToggleOtherSeries: 'Slå av/på andre serier',
    contextMenuToggleSeriesVisibility: 'Veksle synlighet',
    contextMenuZoomToCursor: 'Zoom hit',
    dialogHeaderChannel: 'Kanal',
    dialogHeaderDatePriceRange: 'Dato og pris',
    dialogHeaderDateRange: 'Datoperiode',
    dialogHeaderFibonacciRange: 'Fib Tilbakeretracement',
    dialogHeaderLine: 'Linje',
    dialogHeaderPriceRange: 'Prisklasse',
    dialogHeaderText: 'Tekst',
    dialogInputAlign: 'Justering',
    dialogInputColorPicker: 'Farge',
    dialogInputColorPickerAltText: 'Tekstfarge',
    dialogInputExtendAbove: 'Forleng over',
    dialogInputExtendBelow: 'Utvid nedenfor',
    dialogInputExtendChannelEnd: 'Forleng kanalende',
    dialogInputExtendChannelStart: 'Utvide kanalstart',
    dialogInputExtendLeft: 'Forleng til venstre',
    dialogInputExtendLineEnd: 'Forleng linjeslutt',
    dialogInputExtendLineStart: 'Forleng linjestart',
    dialogInputExtendRight: 'Forleng til høyre',
    dialogInputFibonacciBands: 'Bånd',
    dialogInputFibonacciBandsAltText: 'Fibonacci-bånd',
    dialogInputFillColorPicker: 'Fyll',
    dialogInputFillColorPickerAltText: 'Fyllfarge',
    dialogInputFontSize: 'Størrelse',
    dialogInputFontSizeAltText: 'Skriftstørrelse',
    dialogInputLineStyle: 'Strek',
    dialogInputPosition: 'Posisjon',
    dialogInputReverse: 'Omvendt',
    dialogInputShowFill: 'Vis fyll',
    dialogInputStrokeWidth: 'Tykkelse',
    dialogInputStrokeWidthAltText: 'Linjetykkelse',
    iconAltTextAlignCenter: 'Midtstill',
    iconAltTextAlignLeft: 'Venstre',
    iconAltTextAlignRight: 'Høyre',
    iconAltTextClose: 'Lukk',
    iconAltTextLineStyleDashed: 'Lang-stiplet',
    iconAltTextLineStyleDotted: 'Kort-stiplet',
    iconAltTextLineStyleSolid: 'Heltrukket',
    iconAltTextPositionBottom: 'Bunnen',
    iconAltTextPositionCenter: 'Senter',
    iconAltTextPositionTop: 'Topp',
    inputTextareaPlaceholder: 'Legg til tekst',
    measurerDateRangeBars: '${value}[number] søyler',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Volum ${value}',
    overlayLoadingData: 'Laster data...',
    overlayNoData: 'Ingen data å vise',
    overlayNoVisibleSeries: 'Ingen synlige serier',
    overlayUnsupportedBrowser: 'Ukompatibel nettleserversjon. Vennligst oppgrader nettleseren din.',
    seriesHistogramTooltipCount: '${yName} (antall)',
    seriesHistogramTooltipFrequency: 'Frekvens',
    seriesHistogramTooltipMean: '${yName} (gjennomsnitt)',
    seriesHistogramTooltipSum: '${yName} (sum)',
    toolbarAnnotationsArrow: 'Pil',
    toolbarAnnotationsArrowDown: 'Pil ned',
    toolbarAnnotationsArrowUp: 'Pil opp',
    toolbarAnnotationsCallout: 'Notat',
    toolbarAnnotationsClearAll: 'Fjern alt',
    toolbarAnnotationsComment: 'Kommenter',
    toolbarAnnotationsDatePriceRange: 'Dato og pris',
    toolbarAnnotationsDateRange: 'Datoområde',
    toolbarAnnotationsDelete: 'Slett',
    toolbarAnnotationsDisjointChannel: 'Disjoint kanal',
    toolbarAnnotationsDragHandle: 'Dra-verktøylinje',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fibonnaci Retracement',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Trend Basert',
    toolbarAnnotationsFillColor: 'Fargefyll',
    toolbarAnnotationsHorizontalLine: 'Horisontal linje',
    toolbarAnnotationsLineAnnotations: 'Trendlinjer',
    toolbarAnnotationsLineColor: 'Linjefarge',
    toolbarAnnotationsLineStrokeWidth: 'Linjeslagbredde',
    toolbarAnnotationsLineStyle: 'Linjestil',
    toolbarAnnotationsLock: 'Lås',
    toolbarAnnotationsMeasurerAnnotations: 'Målere',
    toolbarAnnotationsNote: 'Notat',
    toolbarAnnotationsParallelChannel: 'Parallell kanal',
    toolbarAnnotationsPriceRange: 'Prisområde',
    toolbarAnnotationsQuickDatePriceRange: 'Mål',
    toolbarAnnotationsSettings: 'Innstillinger',
    toolbarAnnotationsShapeAnnotations: 'Piler',
    toolbarAnnotationsText: 'Tekst',
    toolbarAnnotationsTextAnnotations: 'Tekstanmerkninger',
    toolbarAnnotationsTextColor: 'Tekstfarge',
    toolbarAnnotationsTextSize: 'Tekststørrelse',
    toolbarAnnotationsTrendLine: 'Trendlinje',
    toolbarAnnotationsUnlock: 'Lås opp',
    toolbarAnnotationsVerticalLine: 'Vertikal linje',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 måned',
    toolbarRange1Year: '1Å',
    toolbarRange1YearAria: '1 år',
    toolbarRange3Months: '3 mnd',
    toolbarRange3MonthsAria: '3 måneder',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 måneder',
    toolbarRangeAll: 'Alle',
    toolbarRangeAllAria: 'Alle',
    toolbarRangeYearToDate: 'Hittil i år',
    toolbarRangeYearToDateAria: 'År til dags dato',
    toolbarSeriesTypeCandles: 'Lysestaker',
    toolbarSeriesTypeDropdown: 'Diagramtype',
    toolbarSeriesTypeHighLow: 'Høy Lav',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Tom lysestake',
    toolbarSeriesTypeLine: 'Linje',
    toolbarSeriesTypeLineWithMarkers: 'Linje med markører',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Trinnlinje',
    toolbarZoomPanEnd: 'Panorer til slutten',
    toolbarZoomPanLeft: 'Panorer til venstre',
    toolbarZoomPanRight: 'Panorer til høyre',
    toolbarZoomPanStart: 'Panorer til start',
    toolbarZoomReset: 'Tilbakestill zoom',
    toolbarZoomZoomIn: 'Zoom inn',
    toolbarZoomZoomOut: 'Zoom ut',
    tooltipPaginationStatus: '${index}[number] av ${count}[number]',
};
